import { create } from 'zustand'

type RefreshState = {
  counter: number
  bump: () => void
}

/**
 * Global "force a refresh now" signal. Components that fetch from bsky
 * subscribe to `counter` and re-fire their refresh effect when it changes.
 * The refresh button in the TopBar profile row calls bump().
 */
export const useRefresh = create<RefreshState>((set, get) => ({
  counter: 0,
  bump: () => set({ counter: get().counter + 1 }),
}))
